<template>
   <div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div class="sous-titre">Mettre à jour mes informations</div>
         <form @submit.prevent="updateUser">
            <div class="columns container-mobile">
               <div class="column is-half">
                  <b-field label="Nom ou raison sociale">
                     <b-input v-model="form_infos.name" required></b-input>
                  </b-field>
               </div>
               <div class="column is-half">
                  <b-field label="Adresse e-mail">
                     <b-input type="email" v-model="form_infos.email" required></b-input>
                  </b-field>
               </div>
            </div>
            <div class="columns container-mobile">
               <div class="column is-half">
                  <b-field label="Adresse">
                     <b-input v-model="form_infos.adresse"></b-input>
                  </b-field>
               </div>

               <div class="column is-half">
                  <b-field label="Code postal">
                     <b-input v-model="form_infos.code_postal"></b-input>
                  </b-field>
               </div>
            </div>

            <div class="columns container-mobile">
               <div class="column is-half">
                  <b-field label="Ville">
                     <b-input v-model="form_infos.ville"></b-input>
                  </b-field>
               </div>
            </div>
            <div class="container-mobile"><b-button style="margin-bottom:25px" icon-left="check" size="is-medium" native-type="submit" type="is-primary" :loading="loading_form_infos">Valider</b-button></div>
         </form>

         <div class="sous-titre">Modifier mon mot de passe</div>
         <form @submit.prevent="updatePassword">
            <div class="columns container-mobile">
               <div class="column is-half">
                  <b-field label="Mot de passe actuel">
                     <b-input type="password" v-model="form_password.password" required password-reveal></b-input>
                  </b-field>
               </div>
               <div class="column is-half">
                  <b-field label="Nouveau mot de passe">
                     <b-input type="password" v-model="form_password.new_password" required password-reveal></b-input>
                  </b-field>
               </div>
            </div>
            <div class="columns container-mobile">
               <div class="column is-half">
                  <b-field label="Confirmer nouveau mot de passe">
                     <b-input type="password" v-model="form_password.new_password_confirmation" required password-reveal></b-input>
                  </b-field>
               </div>
            </div>

            <div class="container-mobile"><b-button style="margin-top:25px" icon-left="check" size="is-medium" native-type="submit" type="is-primary" :loading="loading_form_infos">Valider</b-button></div>
         </form>
      </div>
   </div>
</template>

<script>
import { BeatLoader } from '@saeris/vue-spinners';
import { Form } from 'vform';

export default {
   components: { BeatLoader },
   data() {
      return {
         loading: false,
         loading_form_infos: false,
         loading_form_password: false,
         form_infos: new Form({
            adresse: '',
            email: '',
            code_postal: '',
            ville: '',
            name: '',
            notif: ''
         }),
         form_password: new Form({
            password: '',
            new_password: '',
            new_password_confirmation: ''
         })
      };
   },
   computed: {
      user() {
         return this.$store.state.user.data;
      }
   },
   created() {
      this.getInfos();
      this.$store.commit('setTitre', 'Profil');
   },
   methods: {
      getInfos() {
         this.loading = true;
         this.$store.dispatch('getUser').then(() => {
            this.loading = false;
            this.form_infos.fill(this.user);
         });
      },
      updateUser() {
         this.loading_form_infos = true;
         this.form_infos
            .put('/profil/update')
            .then(() => {
               this.getInfos();
               this.loading_form_infos = false;

               this.$buefy.toast.open({
                  message: 'Informations modifées !',
                  type: 'is-success'
               });
            })
            .catch(() => {
               this.$buefy.toast.open({
                  message: "Une erreur s'est produite, veuillez réessayer ultérieurement.",
                  type: 'is-danger'
               });
               this.loading_form_infos = false;
            });
      },
      updatePassword() {
         this.loading_form_password = true;
         this.form_password
            .put('/profil/update-password')
            .then(res => {
               if (res.data.erreur) {
                  this.$buefy.toast.open({
                     message: res.data.erreur,
                     type: 'is-danger'
                  });
               } else {
                  this.$buefy.toast.open({
                     message: 'Mot de passe modifé !',
                     type: 'is-success'
                  });
                  this.form_password.reset();
               }
               this.loading_form_password = false;
            })
            .catch(() => {
               this.$buefy.toast.open({
                  message: "Une erreur s'est produite.",
                  type: 'is-danger'
               });
               this.loading_form_password = false;
            });
      }
   }
};
</script>
